import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface EndBillingUnpaidDialogData {
  memberId: number;
  subgroupId: number | null;
}

export type EndBillingUnpaidDialogResult = 'notify' | 'cancel';

@Component({
  selector: 'app-fee-end-billing-unpaid-dialog',
  templateUrl: './fee-end-billing-unpaid-dialog.component.html',
  styleUrls: ['./fee-end-billing-unpaid-dialog.component.scss']
})
export class FeeEndBillingUnpaidDialogComponent {

  constructor(
    private readonly dialogRef: MatDialogRef<FeeEndBillingUnpaidDialogComponent, EndBillingUnpaidDialogResult>,
    @Inject(MAT_DIALOG_DATA) readonly data: EndBillingUnpaidDialogData
  ) {}

  sendNotification(): void {
    this.dialogRef.close('notify');
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }
}
